import { render, staticRenderFns } from "./userlimit.vue.html?vue&type=template&id=c3c78fc0"
import script from "./userlimit.controller.ts?vue&type=script&lang=js&external"
export * from "./userlimit.controller.ts?vue&type=script&lang=js&external"
import style0 from "./userlimit.vue.html?vue&type=style&index=0&id=c3c78fc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports